var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tooltip",class:_vm.computedClass,style:({top: _vm.top+'px',  left: _vm.left+'px', 'max-width':_vm.maxWidth+'px', right: _vm.right+'px' })},[_c('div',{staticClass:"c-tooltip__wrap",style:({'max-width':_vm.maxWidth+'px'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }